import { DEFAULT_LOCATION_ID, ROMA_LOCATION_ID } from "./platform";

export type EventBookingSpace = { key: string; label: string; bookable?: boolean };

/** Existing public form offerings, explicitly scoped to the two restaurant locations. */
const PUBLIC_EVENT_SPACES: Record<string, readonly EventBookingSpace[]> = {
  [DEFAULT_LOCATION_ID]: [
    { key: "main_dining", label: "Dining Room" },
    { key: "full_buyout", label: "Full Buyout" },
    { key: "patio", label: "Outdoor Patio" },
    { key: "private_event_space", label: "Private Event Space" },
  ],
  [ROMA_LOCATION_ID]: [
    { key: "main_dining", label: "Dining Room" },
    { key: "full_buyout", label: "Full Buyout" },
    { key: "private_event_space", label: "Private Event Space" },
  ],
};

export function eventBookingSpaces(locationId: string, configured?: readonly EventBookingSpace[] | null): readonly EventBookingSpace[] {
  if (configured) return configured;
  return Object.prototype.hasOwnProperty.call(PUBLIC_EVENT_SPACES, locationId) ? PUBLIC_EVENT_SPACES[locationId] : [];
}
